<template>
  <div v-loading="!user || !mentor">
    <div v-if="user && mentor">
      <img v-if="user.PictureUri" :src="user.PictureUri" alt="">
      <h1>{{user.FirstName + ' ' + user.LastName}}</h1>
      <p v-if="user.IsMentor">
        Code:
        <a>
          <strong>{{user.MentorCode }}</strong>
        </a>
      </p>
      <p>My Mentor: {{mentor.FirstName}}</p>
      <p>Interests: {{user.UserInterests.map(i => i.UseCategoryName).join(', ')}}</p>
      <el-row align="middle" type="flex" justify="center" :gutter="20">
        <el-col :sm="{span: 12}" :lg="{span: 8}">
          <el-tabs type="border-card" v-model="activeTab">
            <el-tab-pane label="General" name="General">
              <el-form ref="form" :model="form" label-width="90px">
                <el-form-item label="First Name">
                  <el-input v-model="form.FirstName"></el-input>
                </el-form-item>
                <el-form-item label="Last Name">
                  <el-input v-model="form.LastName"></el-input>
                </el-form-item>
                <el-form-item label="Email">
                  <el-input v-model="form.Email"></el-input>
                </el-form-item>
                <el-form-item label="Phone">
                  <el-input v-model="form.PhoneNumber"></el-input>
                </el-form-item>
                <el-form-item label="Address">
                  <el-input placeholder="Street Address" v-model="form.Address1"></el-input>
                  <!-- <el-input v-model="form.Address2"></el-input> -->
                  <el-input placeholder="City" v-model="form.City"></el-input>
                  <el-input placeholder="State" v-model="form.State"></el-input>
                  <el-input placeholder="Country" v-model="form.Country"></el-input>
                </el-form-item>
                <el-button :disabled="!hasFormChanged" @click="submitUpdateUser">Update</el-button>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="Login" name="Login">
              <el-form v-if="!changePassword" label-width="90px">
                <el-form-item label="Email">{{form.Email}}</el-form-item>
                <el-form-item label="Password">
                  <el-button @click="changePassword = true">Change Password</el-button>
                </el-form-item>
              </el-form>
              <el-form v-else ref="loginForm" :model="form" label-width="120px">
                <el-form-item label="Old Password">
                  <el-input type="password" v-model="loginForm.CurrentPassword"></el-input>
                </el-form-item>
                <el-form-item label="New Password">
                  <el-input type="password" v-model="loginForm.NewPassword"></el-input>
                </el-form-item>
                <el-form-item label="Confirm">
                  <el-input type="password" v-model="loginForm.ConfirmPassword"></el-input>
                </el-form-item>
                <el-button @click="changePassword = false">Cancel</el-button>
                <el-button
                  @click="submitUpdatePassword"
                  :disabled="disablePasswordSubmit"
                  type="primary"
                >Save New Password</el-button>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      activeTab: 'General',
      form: {
        FirstName: '',
        LastName: '',
        Email: '',
        PhoneNumber: '',
        Address1: '',
        Address2: '',
        City: '',
        State: '',
        Country: ''
      },
      changePassword: false,
      loginForm: {
        CurrentPassword: '',
        NewPassword: '',
        ConfirmPassword: ''
      }
    }
  },
  computed: {
    ...mapGetters(['user', 'mentor']),
    hasFormChanged() {
      return JSON.stringify(this.user) !== JSON.stringify(this.form)
    },
    disablePasswordSubmit() {
      return (
        this.loginForm.NewPassword !== this.loginForm.ConfirmPassword ||
        this.loginForm.NewPassword === ''
      )
    }
  },
  methods: {
    setFormUser(user) {
      if (!user) return
      this.form = Object.assign({}, user)
    },
    submitUpdateUser() {
      this.$store.dispatch('updateUser', this.form)
    },
    submitUpdatePassword() {
      const passwordRequest = Object.assign(
        { UserId: this.user.Id },
        this.loginForm
      )
      this.$store.dispatch('updatePassword', passwordRequest)
      this.changePassword = false
      this.loginForm.CurrentPassword = ''
      this.loginForm.NewPassword = ''
      this.loginForm.ConfirmPassword = ''
    }
  },
  watch: {
    user: {
      handler: 'setFormUser',
      immediate: true
    }
  }
}
</script>

<style>
</style>
